module.exports = __webpack_public_path__ + "images/syuccho_kaitori_lp/cases/q1@2x_670d4c005629bf064700d3114b64f290.png";